import { getAllDetails } from '../../service/ApiService';
import { PENDING_TAX_FORM_LIST } from '../../config/ApiConstant';
import CommonTaxFileList from './CommonTaxFileList';

const PendingFileList = () => {
    const fetchData = async (searchStr?: string) => {
        let endpoint = `${PENDING_TAX_FORM_LIST}?type=Pending`;
        if (searchStr) {
            endpoint += `&search=${searchStr}`;
        }
        const response = await getAllDetails(endpoint);
        const data = Array.isArray(response)
            ? response
            : (response?.pending_list || response?.data || []);
        return data;
    };

    return (
        <CommonTaxFileList
            fetchData={fetchData}
            pageTitle="Pending List"
            breadcrumbMenu="Pending List"
            storagePrefix="pendingList"
            emptyMessage="No pending list found."
        />
    );
};

export default PendingFileList;